import { useLocation } from "wouter";

/**
 * Hook version that uses wouter's useLocation.
 * Only use this inside components that are guaranteed to be within a Router context.
 *
 * For non-hook usage (e.g., in query `enabled` options), use `isSharedThreadPath`
 * from `@/lib/sharedThread.ts` instead.
 */
export const useIsSharedThread = () => {
  const [location] = useLocation();
  return location?.includes("/shared/");
};
